import { cloneDeep } from 'lodash';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

import { ContractProvider } from '../providers/contract.provider';
import { ProductInterface, SelectedProductInterface } from '../data';
import { ProductProvider } from '../providers/product.provider';
import { Transaction } from '../transaction/transaction';
import { UseCaseWithParam } from './common/use.case.with.params';

export interface AddSelectedProductRefundUseCaseParams {
    product: ProductInterface;
}

@Injectable()
export class AddSelectedProductRefundUseCase
    implements UseCaseWithParam<AddSelectedProductRefundUseCaseParams, Observable<Transaction<SelectedProductInterface>>>
{
    constructor(private contractProvider: ContractProvider, private productProvider: ProductProvider) {}

    bind(params: AddSelectedProductRefundUseCaseParams): Observable<Transaction<SelectedProductInterface>> {
        return this.contractProvider.current().pipe(
            switchMap((transaction) =>
                transaction.map(
                    (contract) =>
                        this.productProvider.addSelected(contract.encryptedCode, [params.product]).pipe(
                            map((transactionAdd) =>
                                transactionAdd.map(
                                    (selectedProducts) => Transaction.success(cloneDeep(selectedProducts[0])),
                                    (throwable) => Transaction.error(throwable.message)
                                )
                            )
                        ),
                    (throwable) => of(Transaction.error(throwable.message))
                )
            )
        );
    }
}
